import React, {useCallback, useEffect} from 'react';
import {ReactComponent as NoticeIcon} from '../../../../../../assets/main/course/notice.svg';
import {useAppDispatch, useAppSelector} from "../../../../../../common/hook";
import {useParams} from "react-router-dom";
import {
    fetchCourseById
} from "../../../../../../features/model/service/courses/curses-by/get-curses-by-id/fetchCourseById";
import {
    getBankTransfer
} from "../../../../../../features/model/service/courses/curses-by/get-bank-transfer/getBankTransfer";
import {getPdf} from "../../../../../../features/model/service/courses/curses-by/get-pdf/getPdf";
import {
    printLoadPdf
} from "../../../../../../features/model/service/courses/curses-by/print-pdf-handler/printPdfHandler";
import usePriceCalculator from "../../../../../../common/hook/use-price-calculator";


export const AccountContainer = () => {
    const dispatch = useAppDispatch();
    const {curseId, trackingId} = useParams();
    const BankTransferData = useAppSelector(state => state.bankTransfer?.bankTransfer);
    const numberOfLessons = BankTransferData?.numberOfLessons ?? 0;
    const lessonPrice = BankTransferData?.lessonPrice ?? 0;

    const {formattedTotalPrice, formattedOriginalPrice} = usePriceCalculator(
        numberOfLessons,
        lessonPrice,
        BankTransferData?.discount
    );


    // useEffect(() => {
    //     dispatch(fetchCourseById(curseId));
    // }, [dispatch, curseId]);


    useEffect(() => {
        dispatch(getBankTransfer(trackingId));
    }, [dispatch, trackingId]);


    const downloadPdfHandler = useCallback(async () => {
        if (trackingId) {
            try {
                await dispatch(getPdf(trackingId));
            } catch (error) {
                console.error('Error downloading PDF', error);
            }
        }
    }, [dispatch, trackingId]);


    const printPdfHandler = useCallback(async () => {
        if (trackingId) {
            try {
                const action = await dispatch(printLoadPdf(trackingId));
                const url = action.payload as string | URL;

                if (url) {
                    window.open(url.toString(), "_blank");
                }
            } catch (error) {
                console.error("Error opening PDF", error);
            }
        }
    }, [dispatch, trackingId]);


    return (
        <>
            <div className="data-cards-box equal-height-cards">
                <div className="data-card">
                    <div className="row">
                        <p className="row-title">Реквизиты компании</p>
                        <p className="requisites"
                           dangerouslySetInnerHTML={{__html: BankTransferData?.requisites || ''}}></p>
                    </div>
                </div>
                <div className="data-card">
                    <div className="row">
                        <p className="row-title">Имя</p>
                        <p>{BankTransferData?.fullName}</p>
                    </div>
                    <div className="row">
                        <p className="row-title">Email</p>
                        <p>
                            <a href={BankTransferData?.email}>{BankTransferData?.email}</a>
                        </p>
                    </div>
                    <div className="row">
                        <p className="row-title">ID оплаты</p>
                        <p>{BankTransferData?.trackingId}</p>
                    </div>
                    <div className="row">
                        <p className="row-title">Дата счета</p>
                        <p>{BankTransferData?.date}</p>
                    </div>
                </div>
                <div className="data-card">
                    <p className="h4">{BankTransferData?.courseTitle}</p>
                    <div className="payment-data-tbl">
                        <div className="tbl-row">
                            <div className="col col-title">Занятий</div>
                            <div className="col">{BankTransferData?.numberOfLessons}</div>
                        </div>
                        <div className="tbl-row">
                            <div className="col col-title">Цена за единицу</div>
                            <div className="col">{BankTransferData?.lessonPrice} BYN</div>
                        </div>
                        <div className="tbl-row">
                            <div className="col col-title">Итого</div>
                            <div className="col">{formattedTotalPrice} BYN</div>
                        </div>
                    </div>
                    <div className="total-price">
                        <p className="price h3">{formattedTotalPrice} BYN</p>
                        {BankTransferData?.discount !== 0 && (
                            <div className="price-sub-data">
                                <>
                                    <span>{BankTransferData?.discount}%</span>
                                    <span className="line-through">{formattedOriginalPrice} BYN</span>
                                </>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="btns-box aside-btns">
                <div className="col btns-col left-position">
                    <div style={{boxShadow: 'none'}}>
                        <button
                            type="button"
                            className="btn"
                            onClick={downloadPdfHandler}
                        >
                            <span>Скачать счет</span>
                        </button>
                    </div>

                    <button
                        type="button"
                        className="btn secondary print-action"
                        onClick={printPdfHandler}
                    >
                        <span>Распечатать</span>
                    </button>

                </div>

            </div>
        </>
    )
        ;
};

// <div className="account-tooltip">
//                                     <span className="icon pointer-elem">
//                                         <NoticeIcon/>
//                                     </span>
//     <div className="tooltip-text">Tooltip Text Description</div>
// </div>
